import { useEffect } from 'react'
import {
  CenteredCheckinInput,
  Check,
  Translate,
} from '@innovatrics/checkin-components'
import { Box, Container, Grid, Typography, useMediaQuery } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'

import { CheckinCustomer } from '../generated/graphql'

export interface ResultsProps {
  hotelName: String
  data: CheckinCustomer
}

export const Results = ({ hotelName, data }: ResultsProps) => {
  const navigate = useNavigate()
  const { hash, id } = useParams()
  const matches = useMediaQuery('(min-width:750px)')
  useEffect(() => {
    if (!data?.checkinNumber) navigate(`/reset/${hash}`)
  }, [])
  return (
    <Container maxWidth="md">
      <Grid
        container
        justifyContent="center"
        flexDirection={'column'}
        alignItems={'center'}
        gap={'12px'}
      >
        <Box
          width={matches ? '80px' : '67px'}
          sx={{ marginTop: matches ? '50px' : '46px' }}
        >
          <Check />
        </Box>
        <Typography
          align="center"
          fontSize={matches ? '24px' : '20px'}
          fontWeight={600}
          color="text.primary"
        >
          <Translate
            entityName={'customer.result.title'}
            defaultMessage={'Thanks you for your online check-in.'}
          />
        </Typography>
        <Typography
          align="center"
          fontSize={'14px'}
          fontWeight={400}
          color="text.primary"
          maxWidth={'768px'}
        >
          <Translate
            entityName={'customer.result.text'}
            defaultMessage={
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea.'
            }
          />
        </Typography>
        <div style={{ margin: matches ? '25px 0' : '15px 0 20px 0' }}>
          <Typography
            align="center"
            fontSize={'16px'}
            fontWeight={600}
            color="text.primary"
          >
            <Translate
              entityName={'customer.result.hotelName'}
              defaultMessage={'Lorem ipsum'}
            />
             <span style={{ fontWeight: '400' }}>{hotelName}</span>
          </Typography>
          <Typography
            align="center"
            fontSize={'16px'}
            fontWeight={600}
            color="text.primary"
          >
            <Translate
              entityName={'customer.result.checkinDate'}
              defaultMessage={'Lorem ipsum'}
            />
             
            <span style={{ fontWeight: '400' }}>
              {
                new Date(data?.dateOfArrival)
                  .toLocaleString('en-GB')
                  .split(',')[0]
              }
            </span>
          </Typography>
        </div>
        <Typography
          align="center"
          fontSize={'14px'}
          fontWeight={600}
          color="#E5352B"
        >
          <Translate
            entityName={'customer.result.warning'}
            defaultMessage={'Lorem ipsum'}
          />
        </Typography>
        <CenteredCheckinInput
          id="outlined-basic"
          variant="outlined"
          inputProps={{
            style: { fontSize: matches ? '20px' : '16px', height: '27px' },
          }}
          value={data?.checkinNumber}
          sx={{
            borderRadius: '8px',
            width: matches ? '370px' : '100%',
          }}
        />
      </Grid>
    </Container>
  )
}
